import React from 'react'

const Tasks = () => {
  return (
    <div>
      <p>Tasks</p>
    </div>
  )
}

export default Tasks
